import React from "react";
import { Nav } from "react-bootstrap";
import { Link } from "react-router-dom";

export default function StepNav({
    steps, activeKey, completedSteps = {}
}) {
    return (
        <Nav activeKey={activeKey} className="steps-nav">{
            steps.map((step, index) => (
                <Nav.Item key={index} >
                    <Nav.Link
                        as={Link}
                        to={`/${step.path}`}
                        disabled
                        eventKey={step.key}
                        data-test={completedSteps[step.key]}
                        className={`steps-link ${completedSteps[step.key] === true ? "completed" : ""}`}>
                        {step.label}
                    </Nav.Link>
                </Nav.Item>
            ))
        }
        </Nav>
    );
}